import React, { useEffect, useContext, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import _CK from "@util/cookie";
import _API from "@util/api";

import { AppContext } from "@component/AppProvider";
import Layout from "@layout/Default";
import Loading from "@component/UI/Loading";

import IndexPage from "./pages";
import { AbstractRegistStep1, AbstractRegistStep2 } from "./pages/Abstract";
import { Lang as TestLangPage, LinkTestPage } from "./pages/Test";
import ContentPage from "./pages/Content";
import JoinPage, { Final as JoinFinalPage, Find as JoinFindPage } from "./pages/Join";
import { RegistrationStep1, RegistrationStep2, RegistrationStep3 } from "./pages/Registration";
import { MypageMainPage, MypageInforPage, MypageModifyForm, MypageRegistrationPage, MypageAbstractPage, MypageAbstractViewPage, MypageCertPage } from "./pages/Mypage";

import { BbsListPage, PhotoListPage, BbsViewPage } from "./pages/Bbs";

export default () => {
    const { saveSite, t } = useContext(AppContext);
    const [isLoading, setIsLoading] = useState(true);

    const loadSite = () => {
        _API.get({ path: "/site" })
            .then((res) => res.data)
            .then((site) => {
                saveSite(site);

                const link = document.createElement("link");
                link.href = `${process.env.CDN_URL}/resource/${site.siteCode}.css`;
                link.rel = "stylesheet";
                link.type = "text/css";
                link.id = "main-css";
                document.body.appendChild(link);
                setTimeout(() => {
                    setIsLoading(false);
                }, [500]);
            })
            .catch((e) => _API.alert({ message: e.message }).then(() => (document.location.href = process.env.FRONT_URL)));
    };

    useEffect(() => {
        loadSite();
    }, []);

    if (isLoading) return <Loading />;

    return (
        <Router>
            <Layout>
                <Routes>
                    <Route path="/" element={<IndexPage />} />
                    <Route path="/join" element={<JoinPage />} />
                    <Route path="/join/final" element={<JoinFinalPage />} />
                    <Route path="/join/find" element={<JoinFindPage />} />

                    <Route path="/mypage" element={<MypageMainPage />} />
                    <Route path="/mypage/infor" element={<MypageInforPage />} />
                    <Route path="/mypage/modify" element={<MypageModifyForm />} />
                    <Route path="/mypage/registration" element={<MypageRegistrationPage />} />
                    <Route path="/mypage/abstract" element={<MypageAbstractPage />} />
                    <Route path="/mypage/abstract/:idx" element={<MypageAbstractViewPage />} />
                    <Route path="/mypage/cert" element={<MypageCertPage />} />

                    <Route path="/abstract/regist" element={<AbstractRegistStep1 />} />
                    <Route path="/abstract/regist/:idx" element={<AbstractRegistStep2 />} />

                    <Route path="/abstract/modify/step1/:idx" element={<AbstractRegistStep1 />} />
                    <Route path="/abstract/modify/step2/:idx" element={<AbstractRegistStep2 />} />

                    <Route path="/registration/regist" element={<RegistrationStep1 />} />
                    <Route path="/registration/regist/step2" element={<RegistrationStep2 />} />
                    <Route path="/registration/regist/step3" element={<RegistrationStep3 />} />

                    <Route path="/bbs/photo" element={<PhotoListPage />} />
                    <Route path="/bbs/:code" element={<BbsListPage />} />
                    <Route path="/bbs/:code/:idx" element={<BbsViewPage />} />

                    <Route path="/test/lang" element={<TestLangPage />} />
                    <Route path="/c/:code1" element={<ContentPage />} />
                    <Route path="/c/:code1/:code2" element={<ContentPage />} />
                    <Route path="/c/:code1/:code2/:code3" element={<ContentPage />} />
                    <Route path="/test/link" element={<LinkTestPage />} />
                    <Route path="*" element={<Navigate replace to="/" />} />
                </Routes>
            </Layout>
        </Router>
    );
};
